import Vue from "vue";
import Vuex from "vuex";
import main from "./modules/main";
import forget from "./modules/forget";
import reset from "./modules/reset";
import protocol from "./modules/protocol";
import information from "./modules/information";
import activity from "./modules/activity";
import flight from "./modules/flight";
import hotel from "./modules/hotel";
import document from "./modules/document";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
	modules: {
		main,
		forget,
		reset,
		protocol,
		information,
		activity,
		flight,
		hotel,
		document
	},
	strict: debug
});
